export default "__VITE_ASSET__DLH9Wxqc__"